import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { DropdownFieldWUT } from '../../../ui/dropdown-field';
import { useServiceDropdownOptions } from '../utils/use-service-dropdown-options';
export const ServiceDropdownWUT = props => {
  const fieldType = FIELD_TYPES.SERVICES_DROPDOWN;
  const {
    isLoading,
    options,
    isEmpty,
    onFocus,
    onChange
  } = useServiceDropdownOptions(props);
  if (!props.isEditor && isEmpty) {
    return null;
  }
  return /*#__PURE__*/React.createElement(DropdownFieldWUT, _extends({}, props, {
    onFocus: onFocus,
    onChange: onChange,
    fieldType: fieldType,
    options: isLoading ? [] : options,
    isLoading: isLoading
  }));
};
//# sourceMappingURL=service-dropdown-wut.js.map